/* Pizeta — Stima consegna dinamica + countdown live
   Legge config da data-attributes sull'elemento [data-pz-delivery]:
   - data-days-min:      giorni min di consegna (int)
   - data-days-max:      giorni max di consegna (int)
   - data-cutoff-hour:   ora cutoff giornaliera 24h (int)
   - data-skip-weekend:  "true" per saltare sab/dom nel calcolo
*/
(function () {
  'use strict';

  const MONTHS_IT = [
    'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
    'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'
  ];

  function addBusinessDays(date, days, skipWeekend) {
    const d = new Date(date);
    let remaining = days;
    if (!skipWeekend) {
      d.setDate(d.getDate() + days);
      return d;
    }
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay(); // 0 = domenica, 6 = sabato
      if (dow !== 0 && dow !== 6) remaining--;
    }
    return d;
  }

  function formatRange(startDate, endDate) {
    const sameMonth = startDate.getMonth() === endDate.getMonth();
    const sameYear = startDate.getFullYear() === endDate.getFullYear();
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startMonth = MONTHS_IT[startDate.getMonth()];
    const endMonth = MONTHS_IT[endDate.getMonth()];
    if (sameMonth && sameYear) {
      return `tra il ${startDay} e il ${endDay} ${endMonth}`;
    }
    return `tra il ${startDay} ${startMonth} e il ${endDay} ${endMonth}`;
  }

  function formatCountdown(diffMs) {
    const totalMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours <= 0 && minutes <= 0) return '';
    if (hours <= 0) {
      return `${minutes} ${minutes === 1 ? 'minuto' : 'minuti'}`;
    }
    if (minutes <= 0) {
      return `${hours} ${hours === 1 ? 'ora' : 'ore'}`;
    }
    return `${hours} ${hours === 1 ? 'ora' : 'ore'} e ${minutes} ${minutes === 1 ? 'minuto' : 'minuti'}`;
  }

  function render(container) {
    const textNode = container.querySelector('[data-pz-delivery-text]');
    if (!textNode) return;

    const daysMin = parseInt(container.dataset.daysMin, 10) || 2;
    const daysMax = parseInt(container.dataset.daysMax, 10) || 3;
    const cutoffHour = parseInt(container.dataset.cutoffHour, 10);
    const skipWeekend = container.dataset.skipWeekend === 'true';

    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(isFinite(cutoffHour) ? cutoffHour : 14, 0, 0, 0);

    // Se cutoff già passato oggi → offset di +1 giorno base (l'ordine parte domani)
    const pastCutoff = now.getTime() >= cutoff.getTime();
    let baseDate = new Date(now);
    if (pastCutoff) {
      baseDate.setDate(baseDate.getDate() + 1);
      // Se domani è weekend e skipWeekend, sposta a lunedì
      if (skipWeekend) {
        while (baseDate.getDay() === 0 || baseDate.getDay() === 6) {
          baseDate.setDate(baseDate.getDate() + 1);
        }
      }
    }

    const startDate = addBusinessDays(baseDate, daysMin, skipWeekend);
    const endDate = addBusinessDays(baseDate, daysMax, skipWeekend);
    const rangeStr = formatRange(startDate, endDate);

    if (pastCutoff) {
      textNode.textContent = `Consegna in 24/48 h.`;
    } else {
      const countdown = formatCountdown(cutoff.getTime() - now.getTime());
      if (countdown) {
        textNode.textContent = `Consegna in 24/48 h. Ordina entro ${countdown}.`;
      } else {
        textNode.textContent = `Consegna in 24/48 h.`;
      }
    }
  }

  function init() {
    const containers = document.querySelectorAll('[data-pz-delivery]');
    containers.forEach(render);
  }

  // Refresh ogni 60 secondi (per aggiornare countdown minuto per minuto)
  function startRefresh() {
    init();
    setInterval(init, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRefresh);
  } else {
    startRefresh();
  }

  // Re-init quando Shopify theme editor ricarica la sezione
  document.addEventListener('shopify:section:load', init);
})();
